import styled from "styled-components";
import { themes } from "../../../theme/theme";

const ImageLink = styled.a`
  background: ${themes.colors.colorGray7};
  width: 6rem;
  height: 6rem;
  margin: 0 0.5rem;
  display: flex;
  float: left;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 2rem;
    height: 2rem;
  }
  :hover {
    filter: brightness(0.9);
  }
  @media ${themes.device.tablet} {
    float: left;
  }
  @media (max-width: 470px) {
    margin: 0 0.5rem;
  }

  @media (max-width: 385px) {
    width: 4rem;
    height: 4rem;
  }
`;

const Container = styled.div`
  margin-top: 5rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  height: 13rem;
  align-items: center;
  padding: 0 10%;

  @media ${themes.device.tablet} {
    padding: 0 7%;
  }
  @media ${themes.device.tabletS} {
    padding: 0 3%;
    margin-top: 2rem;
  }
  .h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 2.8rem;
    line-height: 132.5%;
    color: white;

    @media ${themes.device.tabletS} {
      font-size: 2.4rem;
    }
  }
`;
export { ImageLink, Container };
